import { render, staticRenderFns } from "./NewAchievementModal.vue?vue&type=template&id=15a45f4a&scoped=true&"
import script from "./NewAchievementModal.vue?vue&type=script&lang=js&"
export * from "./NewAchievementModal.vue?vue&type=script&lang=js&"
import style0 from "./NewAchievementModal.vue?vue&type=style&index=0&id=15a45f4a&scoped=true&lang=scss&"
import style1 from "./NewAchievementModal.vue?vue&type=style&index=1&id=15a45f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a45f4a",
  null
  
)

export default component.exports